import { DateFormatService } from 'src/app/services/dateFormat.service';

export function toTimestampMs(
  value: Date | string | number | null | undefined,
  dateFormatService: DateFormatService,
): number | null {
  if (value == null) {
    return null;
  }

  if (typeof value === 'number') {
    if (!Number.isFinite(value) || value <= 0) {
      return null;
    }

    return dateFormatService.normalizeTimestamp(value);
  }

  if (value instanceof Date) {
    const timestamp = value.getTime();
    return Number.isFinite(timestamp) && timestamp > 0 ? timestamp : null;
  }

  const numericTimestamp = Number(value);
  if (Number.isFinite(numericTimestamp) && numericTimestamp > 0) {
    return dateFormatService.normalizeTimestamp(numericTimestamp);
  }

  const parsedTimestamp = new Date(value).getTime();
  return Number.isFinite(parsedTimestamp) && parsedTimestamp > 0 ? parsedTimestamp : null;
}
